import React from "react";
import { Bar } from "react-chartjs-2";
import { euroFormatter } from "src/global";
import ChartCard from "../ChartCard";

const AccessSystemRevenueChart = ({ chart }) => {
  const data = {
    ...chart.data,
    datasets: chart.data.datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: "rgba(34, 197, 94, 0.7)",
      borderRadius: 6,
    })),
  };

  return (
    <ChartCard
      chart={chart}
      summary={`${chart.total_label}: ${euroFormatter(chart.total)}`}
    >
      {chart.data.labels.length === 0 ? (
        <div className="h-100 d-flex align-items-center justify-content-center text-muted">
          {chart.empty_message}
        </div>
      ) : (
        <Bar
          data={data}
          options={{
            indexAxis: "y",
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                beginAtZero: true,
                ticks: {
                  callback: (value) => euroFormatter(Number(value)),
                },
              },
              y: { ticks: { autoSkip: false } },
            },
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: (context) => euroFormatter(context.parsed.x),
                },
              },
            },
          }}
        />
      )}
    </ChartCard>
  );
};

export default AccessSystemRevenueChart;
